module.exports = __webpack_public_path__ + "img/logo.fa6b1b55.png";